import { styled, TextField as MuiTextField } from '@mui/material';

export const Wrapper = styled('div')(() => ({ width: '100%' }));

export const StyledTextField = styled(MuiTextField)<{
  background?: 'transparent' | 'white' | 'undefined';
  error?: boolean;
  lightError?: boolean;
}>(({ theme, disabled, background = 'transparent', error, lightError }) => ({
  '& .MuiOutlinedInput-root': {
    backgroundColor: disabled
      ? theme.palette.grey[50]
      : error && !lightError
        ? theme.palette.error.light
        : background === 'transparent'
          ? 'transparent'
          : theme.palette.common.white,
    fontSize: '13px',
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.divider,
    },
    '&.Mui-error .MuiOutlinedInput-notchedOutline, &.Mui-focused.Mui-error .MuiOutlinedInput-notchedOutline, &.Mui-focused .MuiOutlinedInput-notchedOutline':
      {
        borderColor: error || lightError ? theme.palette.error.main : theme.palette.divider,
      },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: error || lightError ? theme.palette.error.main : theme.palette.grey[400],
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: error || lightError ? theme.palette.error.main : theme.palette.primary.main,
    },
  },
}));
